import { render, staticRenderFns } from "./tool-prev.vue?vue&type=template&id=231b87f1&scoped=true&"
import script from "./tool-prev.vue?vue&type=script&lang=js&"
export * from "./tool-prev.vue?vue&type=script&lang=js&"
import style0 from "./tool-prev.vue?vue&type=style&index=0&id=231b87f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b87f1",
  null
  
)

export default component.exports